const CURRENCY = 'currency';
const DECIMAL = 'decimal';

const getPriceParts = (rawPrice, locale, currency = 'USD', formattingOptions = {
  leadingCurrency: false
}) => {
  const options = {
    style: CURRENCY,
    currency: currency,
    minimumFractionDigits: 2
  };

  const formatter = new Intl.NumberFormat(locale, options);
  const price = parseFloat(rawPrice);
  const priceParts = formatter.formatToParts(price);
  const decimalPart = priceParts.find(({ type }) => type === DECIMAL);
  const currencyPart = priceParts.find(({ type }) => type === CURRENCY);
  const localedCurrency = currencyPart.value;
  const formattedValue = formatter.format(price);

  let value = formattedValue;

  if (formattingOptions.leadingCurrency) {
    const purePrice = formattedValue.replace(localedCurrency, '').trim();

    value = localedCurrency + purePrice;
  }

  const currencyValue = currencyPart.value;
  const decimalDivider = decimalPart.value;
  const valueWithoutCurrency = value.replace(currencyValue, '').trim();
  const [integer, fraction] = valueWithoutCurrency.split(decimalDivider);

  return {
    currency: currencyPart.value,
    integer: integer.trim(),
    fraction: fraction.trim(),
    decimalDivider,
    value,
  };
};

export default getPriceParts;
